(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var stickyButton = document.querySelector('[data-sticky-atc-button]');
    var realSubmit = document.querySelector('.product-form__submit');
    if (!stickyBar || !stickyButton || !realSubmit) return;

    stickyButton.addEventListener('click', function () {
      realSubmit.click();
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(realSubmit);
  })();

  // Mobile photo carousel — touch-swipe toggles which flat, absolutely-
  // positioned slide has .is-active (see drop-product-style.liquid for
  // why it's built this way, not a scrollable track). Swipe left = next,
  // swipe right = previous; clamped at the first/last slide that actually
  // has a photo (empty slots are skipped, not swiped into).
  (function () {
    var hero = document.querySelector('[data-mobile-hero]');
    if (!hero) return;
    // Real <img> tags now — only slots with an actual photo get one
    // rendered at all, so every element here already has an image.
    var filled = Array.prototype.slice.call(hero.querySelectorAll('.product__mobile-hero-slide'));
    if (filled.length < 2) return;

    var index = 0;
    var startX = null;

    var goTo = function (newIndex) {
      if (newIndex < 0 || newIndex >= filled.length) return;
      filled[index].classList.remove('is-active');
      filled[newIndex].classList.add('is-active');
      index = newIndex;
    };

    hero.addEventListener(
      'touchstart',
      function (e) {
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );

    hero.addEventListener(
      'touchend',
      function (e) {
        if (startX === null) return;
        var deltaX = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(deltaX) < 40) return;
        goTo(deltaX < 0 ? index + 1 : index - 1);
      },
      { passive: true }
    );
  })();

  // Desktop photo slideshow — separate from the mobile carousel above
  // (doesn't touch it), same one-slide-at-a-time .is-active pattern,
  // arrow-click instead of touch-swipe since desktop has no touch
  // gestures. Clamped like mobile (no wraparound past the first/last
  // photo), not looping.
  (function () {
    var hero = document.querySelector('[data-desktop-hero]');
    if (!hero) return;
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.product__desktop-hero-slide'));
    if (slides.length < 2) return;

    var index = 0;
    var goTo = function (newIndex) {
      if (newIndex < 0 || newIndex >= slides.length) return;
      slides[index].classList.remove('is-active');
      slides[newIndex].classList.add('is-active');
      index = newIndex;
    };

    var prevBtn = hero.querySelector('[data-desktop-hero-prev]');
    var nextBtn = hero.querySelector('[data-desktop-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
  })();

  // Sticky bar's price tag + real tappable size buttons.
  //
  // IMPORTANT: .product__sticky-atc lives INSIDE <product-info>, and Dawn
  // replaces <product-info>'s entire contents (via HTMLUpdateUtility.
  // viewTransition in product-info.js) every time the variant changes —
  // that's how it updates price/availability. That wipes out any buttons
  // we built once at page load and never rebuilt, which is why the sticky
  // buttons stopped staying in sync after the first change. Everything
  // below re-queries the live DOM each time instead of holding onto
  // references that go stale the moment Dawn swaps the markup, and
  // delegates all listening to `document` (which is never replaced).
  (function () {
    var priceTag = document.querySelector('[data-sticky-atc-price]');

    // Dawn's HTMLUpdateUtility.viewTransition (global.js) swaps content via
    // a "double buffer": the NEW node is inserted before the OLD one, the
    // old one gets display: none, and it isn't actually removed from the
    // DOM until 500ms later. For that whole window, both old (hidden) and
    // new radios exist simultaneously — a plain querySelectorAll matches
    // both, which is what caused 3 extra (stale) size buttons to flash in
    // briefly. offsetParent is null for anything display:none (or inside
    // a display:none ancestor), so this filters the hidden duplicates out.
    var getRealRadios = function () {
      return Array.prototype.slice
        .call(document.querySelectorAll('variant-selects input[type="radio"]'))
        .filter(function (r) {
          return r.offsetParent !== null;
        });
    };

    // Full rebuild — called on load AND every time Dawn's swap completes
    // (see the price MutationObserver below, which reliably fires once
    // per real variant change since the price content always updates as
    // part of it). Re-queries .product__sticky-atc-size-options fresh
    // each time too, since the container itself gets replaced along with
    // everything else inside <product-info>.
    var buildStickyButtons = function () {
      var sizeOptions = document.querySelector('[data-sticky-atc-size-options]');
      if (!sizeOptions) return;
      sizeOptions.innerHTML = '';
      getRealRadios().forEach(function (radio) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product__sticky-atc-size-option';
        btn.textContent = radio.value;
        btn.dataset.value = radio.value;
        if (radio.checked) btn.classList.add('is-selected');
        if (radio.classList.contains('disabled')) btn.classList.add('is-unavailable');
        sizeOptions.appendChild(btn);
      });
    };
    buildStickyButtons();

    // Delegated click (document never gets replaced, unlike the buttons
    // themselves) — always re-queries the matching real radio by value at
    // click time rather than closing over a reference that might already
    // be stale.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product__sticky-atc-size-option');
      if (!btn) return;
      var radio = getRealRadios().filter(function (r) {
        return r.value === btn.dataset.value;
      })[0];
      if (!radio) return;

      // Dawn's own product-info.js re-focuses the option that was
      // "clicked" once its async variant update finishes — good for
      // accessibility on the real picker, but since that's the real
      // (off-screen) radio here, the browser auto-scrolls the page down
      // to bring it into view. Only attached for sticky-button clicks —
      // the real picker's own focus/scroll behavior is untouched.
      //
      // A single "snap back on focusin" wasn't enough on iOS Safari:
      // iOS has a long-standing history of not reliably honoring
      // focus({preventScroll:true}) and can animate/delay the scroll
      // rather than jumping instantly, so a one-shot correction can fire
      // before iOS's own scroll actually happens and gets overridden a
      // moment later. Two layers now, not one:
      // 1) Monkey-patch focus() for a few seconds so ANY focus call
      //    (including Dawn's) requests preventScroll — blocks it at the
      //    source where the browser does support the flag.
      // 2) Actively re-assert the scroll position on every animation
      //    frame for ~800ms regardless — a brute-force lock that wins
      //    even if iOS ignores preventScroll and scrolls anyway, since
      //    we just keep pulling it back until iOS's own scroll settles.
      var scrollY = window.scrollY;
      var originalFocus = HTMLElement.prototype.focus;
      HTMLElement.prototype.focus = function (options) {
        return originalFocus.call(this, Object.assign({}, options, { preventScroll: true }));
      };

      var lockUntil = Date.now() + 800;
      var lockScroll = function () {
        if (window.scrollY !== scrollY) window.scrollTo(0, scrollY);
        if (Date.now() < lockUntil) {
          requestAnimationFrame(lockScroll);
        } else {
          HTMLElement.prototype.focus = originalFocus;
        }
      };
      requestAnimationFrame(lockScroll);

      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Instant visual feedback when the REAL picker is tapped directly —
    // just toggles classes on whatever sticky buttons currently exist;
    // the fuller rebuild below (tied to the price observer) is what
    // actually recovers after Dawn's swap wipes the buttons out.
    document.addEventListener('change', function (e) {
      if (!e.target.matches('variant-selects input[type="radio"]')) return;
      var sizeOptions = document.querySelector('[data-sticky-atc-size-options]');
      if (!sizeOptions) return;
      Array.prototype.forEach.call(sizeOptions.querySelectorAll('.product__sticky-atc-size-option'), function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.value === e.target.value && e.target.checked);
      });
    });

    // Price: Dawn updates the real price display asynchronously (fetches
    // and swaps in new section HTML on variant change), so this mirrors it
    // via MutationObserver instead of trying to read it immediately on a
    // change event, which would just catch the stale value. Also the
    // reliable signal used to rebuild the sticky size buttons after every
    // real swap — price content always changes as part of one, even when
    // the size itself doesn't (e.g. same price across all sizes), so this
    // fires exactly when it needs to.
    // Observed on <product-info> itself, not .price — Dawn's swap may
    // replace the .price node entirely (not just mutate its contents),
    // which would silently kill an observer attached directly to it.
    // <product-info> is the stable element Dawn's own code updates in
    // place (confirmed in product-info.js), so it's the safe thing to
    // watch. Re-queries .price fresh inside the callback for the same
    // reason. Disconnect/reconnect around our own writes (price text +
    // rebuilding the sticky buttons) so those mutations don't re-trigger
    // this same observer and recurse.
    var productInfoRoot = document.querySelector('product-info');
    if (productInfoRoot) {
      var priceObserver = new MutationObserver(function () {
        priceObserver.disconnect();

        if (priceTag) {
          var priceRoot = document.querySelector('.price');
          var visible = priceRoot
            ? priceRoot.querySelector('.price-item--sale:not([hidden]), .price-item--regular:not([hidden])')
            : null;
          var text = visible ? visible.textContent.trim() : '';
          if (text) priceTag.textContent = text;
        }
        buildStickyButtons();

        priceObserver.observe(productInfoRoot, { childList: true, subtree: true, characterData: true });
      });
      priceObserver.observe(productInfoRoot, { childList: true, subtree: true, characterData: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-drop"]) return;
  try {
    
  class PasswordDropCountdown extends HTMLElement {
    connectedCallback() {
      // querySelectorAll (not querySelector) — the desktop tile layout and
      // the mobile labeled-card layout both live in this element at once
      // (CSS shows/hides whichever matches the breakpoint), so every digit
      // target has two copies that both need updating each tick.
      this.targetTime = new Date(this.dataset.countdownTarget).getTime();
      this.daysTensEls = this.querySelectorAll('[data-days-tens]');
      this.daysOnesEls = this.querySelectorAll('[data-days-ones]');
      this.hoursTensEls = this.querySelectorAll('[data-hours-tens]');
      this.hoursOnesEls = this.querySelectorAll('[data-hours-ones]');
      this.minutesTensEls = this.querySelectorAll('[data-minutes-tens]');
      this.minutesOnesEls = this.querySelectorAll('[data-minutes-ones]');
      this.secondsTensEls = this.querySelectorAll('[data-seconds-tens]');
      this.secondsOnesEls = this.querySelectorAll('[data-seconds-ones]');

      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const distance = this.targetTime - Date.now();

      if (isNaN(this.targetTime) || distance <= 0) {
        this.render(0, 0, 0, 0);
        clearInterval(this.interval);
        return;
      }

      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      this.render(days, hours, minutes, seconds);
    }

    render(days, hours, minutes, seconds) {
      this.setDigits(this.daysTensEls, this.daysOnesEls, days);
      this.setDigits(this.hoursTensEls, this.hoursOnesEls, hours);
      this.setDigits(this.minutesTensEls, this.minutesOnesEls, minutes);
      this.setDigits(this.secondsTensEls, this.secondsOnesEls, seconds);
    }

    setDigits(tensEls, onesEls, value) {
      const padded = String(value).padStart(2, '0');
      tensEls.forEach((el) => { el.textContent = padded[0]; });
      onesEls.forEach((el) => { el.textContent = padded[1]; });
    }
  }

  customElements.define('password-drop-countdown', PasswordDropCountdown);

  // Swap in shorter placeholder text on mobile only, restoring the
  // original (desktop) placeholder above that breakpoint.
  const mobileBreakpoint = window.matchMedia('(max-width: 749px)');
  function applyMobilePlaceholders() {
    document.querySelectorAll('[data-mobile-placeholder]').forEach((el) => {
      if (el.dataset.desktopPlaceholder === undefined) {
        el.dataset.desktopPlaceholder = el.placeholder;
      }
      el.placeholder = mobileBreakpoint.matches ? el.dataset.mobilePlaceholder : el.dataset.desktopPlaceholder;
    });
  }
  applyMobilePlaceholders();
  mobileBreakpoint.addEventListener('change', applyMobilePlaceholders);

  const passwordDropFlag = document.getElementById('PasswordDropFlag');

  function updatePasswordDropFlagCount() {
    if (!passwordDropFlag) return;
    const subEl = document.getElementById('PasswordDropFlagSub');
    if (!subEl) return;

    const template = subEl.dataset.template || subEl.textContent;
    subEl.dataset.template = template;

    const start = parseInt(passwordDropFlag.dataset.counterStart, 10) || 0;
    const submissions = parseInt(localStorage.getItem('passwordDropSubmissions'), 10) || 0;
    const count = start + submissions;

    subEl.textContent = template.replace('{count}', count);
  }

  function incrementPasswordDropFlagCount() {
    const submissions = (parseInt(localStorage.getItem('passwordDropSubmissions'), 10) || 0) + 1;
    localStorage.setItem('passwordDropSubmissions', String(submissions));
  }

  function showPasswordDropFlag() {
    if (!passwordDropFlag) return;
    updatePasswordDropFlagCount();
    passwordDropFlag.classList.remove('is-visible');
    void passwordDropFlag.offsetWidth;
    passwordDropFlag.classList.add('is-visible');
    clearTimeout(showPasswordDropFlag._hideTimer);
    showPasswordDropFlag._hideTimer = setTimeout(() => {
      passwordDropFlag.classList.remove('is-visible');
    }, 10000);
  }

  const passwordDropEmailForm = document.getElementById('PasswordDropEmailForm');
  if (passwordDropEmailForm) {
    passwordDropEmailForm.addEventListener('submit', (event) => {
      event.preventDefault();

      const input = document.getElementById('PasswordDropEmail');
      const messageEl = document.getElementById('PasswordDropEmail-error');
      const submitButton = passwordDropEmailForm.querySelector('.password-drop__email-submit');
      const publicKey = passwordDropEmailForm.dataset.klaviyoPublicKey;
      const listId = passwordDropEmailForm.dataset.klaviyoListId;
      const value = input ? input.value.trim() : '';
      const isPhone = value !== '' && !value.includes('@');

      if (messageEl) messageEl.textContent = '';

      if (!publicKey || !listId) {
        if (messageEl) messageEl.textContent = 'Signup is not configured yet.';
        return;
      }

      const profileAttributes = {};
      if (isPhone) {
        profileAttributes.phone_number = value;
      } else {
        profileAttributes.email = value;
      }

      if (submitButton) submitButton.disabled = true;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttributes,
                },
              },
            },
            relationships: {
              list: {
                data: { type: 'list', id: listId },
              },
            },
          },
        }),
      })
        .then((response) => {
          if (response.ok || response.status === 202) {
            if (input) input.value = '';
            incrementPasswordDropFlagCount();
            showPasswordDropFlag();
          } else if (messageEl) {
            messageEl.textContent = 'Something went wrong. Please check your info and try again.';
          }
        })
        .catch(() => {
          if (messageEl) messageEl.textContent = 'Something went wrong. Please try again.';
        })
        .finally(() => {
          if (submitButton) submitButton.disabled = false;
        });
    });
  }

  // Mobile timer auto-fit: grows the digit-tile row's font-size from a
  // small floor, step by step, until it would just overflow the
  // .password-drop__timer-fit wrapper (sized in CSS to exactly 1020/1080 =
  // 94.44% of the page width), then backs off one step — so the result can
  // never end up bigger than the frame, only ever approach it from safely
  // under. Growing-into-fit instead of shrinking-from-a-guess so a bad
  // starting guess can't leave it oversized. If this script doesn't run at
  // all, the plain `font-size: 9vw` CSS rule above (deliberately
  // conservative) is the fallback — proportional, no JS dependency.
  const timerFitWrap = document.querySelector('[data-timer-fit]');
  const timerFitEl = document.querySelector('.password-drop__timer');
  if (timerFitWrap && timerFitEl) {
    const TIMER_FIT_MIN_REM = 1.5;
    const TIMER_FIT_MAX_REM = 8;
    const TIMER_FIT_STEP_REM = 0.05;
    let timerFitResizeTimer;

    const fitPasswordDropTimer = () => {
      if (window.matchMedia('(min-width: 750px)').matches) {
        timerFitEl.style.fontSize = '';
        return;
      }
      const target = timerFitWrap.clientWidth;
      if (!target) return;

      let size = TIMER_FIT_MIN_REM;
      timerFitEl.style.fontSize = `${size}rem`;
      while (timerFitEl.scrollWidth <= target && size < TIMER_FIT_MAX_REM) {
        size += TIMER_FIT_STEP_REM;
        timerFitEl.style.fontSize = `${size}rem`;
      }
      if (timerFitEl.scrollWidth > target) {
        size -= TIMER_FIT_STEP_REM;
        timerFitEl.style.fontSize = `${size}rem`;
      }
    };

    fitPasswordDropTimer();
    window.addEventListener('load', fitPasswordDropTimer);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitPasswordDropTimer);
    }
    window.addEventListener('resize', () => {
      clearTimeout(timerFitResizeTimer);
      timerFitResizeTimer = setTimeout(fitPasswordDropTimer, 100);
    });
  }

  // 2026-08-27: .password-drop__timer-group is position: fixed with a
  // `bottom:` offset — the same category of bug the form panels already
  // had fixed for them (see the "top-anchored instead of bottom-anchored
  // now" comment on .password-drop__password/.email above). On iOS, a
  // bottom-anchored fixed element gets dragged upward when the keyboard
  // opens, because WebKit recomputes "bottom: 0" against the visual
  // viewport, and the keyboard just moved that viewport's bottom edge up.
  // The focus/blur scroll-reset below doesn't touch this — nothing is
  // actually scrolling, the anchor point itself is moving. Same fix as
  // the forms already got: stop anchoring from the bottom. The timer's
  // own height depends on the auto-fit sizing above (not a fixed
  // percentage like the forms' was), so this measures its real on-screen
  // position once sizing has settled and pins it with `top` instead —
  // same "measure once, freeze" approach as --frozen-vh/--frozen-vw.
  function pinTimerGroupTop() {
    const group = document.querySelector('.password-drop__timer-group');
    if (!group || group.dataset.pinnedTop) return;
    if (window.matchMedia('(min-width: 750px)').matches) return; // desktop layout doesn't use this fixed group
    const rect = group.getBoundingClientRect();
    if (!rect.height) return; // not laid out yet — wait for a trigger that runs after it is
    group.style.top = `${rect.top}px`;
    group.style.bottom = 'auto';
    group.dataset.pinnedTop = 'true';
  }
  window.addEventListener('load', () => {
    requestAnimationFrame(() => requestAnimationFrame(pinTimerGroupTop));
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      requestAnimationFrame(() => requestAnimationFrame(pinTimerGroupTop));
    });
  }

  // iOS Safari quirk: focusing an <input> inside a position: fixed layout
  // like this one can leave the whole page force-scrolled up (WebKit's own
  // "keep the focused field above the keyboard" behavior) even with
  // overflow: hidden on html/body, and it doesn't reliably undo that scroll
  // once the keyboard closes. The viewport meta fix in layout/password.liquid
  // helps on newer iOS but isn't honored on every version — this is the
  // direct correction: snap the scroll position back to zero on blur.
  // Delayed slightly because iOS sometimes applies its own scroll
  // adjustment just after blur fires, not before.
  //
  // 2026-08-27: that correction only ever ran AFTER typing finished. While
  // the field was still focused and the keyboard was up, the page sat in
  // that force-scrolled state the whole time — WebKit applies its
  // scroll-into-view push right as the field gains focus, not just on
  // blur. Since position: fixed elements move with that forced scroll,
  // this is what showed up as the timer looking like it slid up and
  // landed behind the form once the keyboard-crash fix above stopped the
  // rest of the page from resizing to mask it. Same correction, now also
  // applied on focus, so the page never settles into the scrolled state
  // to begin with.
  document.querySelectorAll('.password-drop__password-input, .password-drop__email-input').forEach((input) => {
    const snapScrollToZero = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    input.addEventListener('focus', () => setTimeout(snapScrollToZero, 50));
    input.addEventListener('blur', () => setTimeout(snapScrollToZero, 50));
  });

  } catch(e) { console.error(e); }
})();
})();
